var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.616 3h5.433c6.038 0 10.95 4.87 10.95 10.854s-4.913 10.852-10.952 10.852H5.246a1.08 1.08 0 0 1-1.082-1.072 1.08 1.08 0 0 1 1.082-1.073H19.05c4.844.001 8.785-3.905 8.785-8.706 0-4.802-3.941-8.708-8.786-8.708h-5.434a1.08 1.08 0 0 1-1.083-1.073A1.08 1.08 0 0 1 13.616 3zm5.433 7.085H5.039a1.08 1.08 0 0 1-1.083-1.073A1.08 1.08 0 0 1 5.039 7.94h14.008c3.29 0 5.967 2.652 5.967 5.913 0 3.261-2.677 5.914-5.967 5.914h-7.58a1.08 1.08 0 0 1-1.082-1.073 1.08 1.08 0 0 1 1.082-1.073h7.58c2.097.001 3.803-1.69 3.803-3.767s-1.705-3.768-3.801-3.768zm-6.278 3.768a1.08 1.08 0 0 0-1.082-1.073H9.052a1.08 1.08 0 0 0-1.083 1.073c0 .594.478 1.073.874 1.073h2.638c.76 0 1.29-.441 1.29-1.073zm-9.69 13.648h6.264a1.08 1.08 0 0 1 1.082 1.073 1.08 1.08 0 0 1-1.082 1.073H3.083A1.08 1.08 0 0 1 2 28.573a1.08 1.08 0 0 1 1.083-1.072z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNct);
export default __webpack_public_path__ + "static/media/NCT.ec3a535ce2a4575f4fadcffb0cecab56.svg";
export { ForwardRef as ReactComponent };